import React, { useState, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { useDispatch } from 'react-redux'
import { Switch, useLocation } from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import { setOpenDrawer } from 'state/application/actions'

interface Props {
  children: React.ReactNode
}

TopBarProgress.config({
  barColors: {
    '0': '#f6b0ff',
    '0.5': '#ed68ff',
    '1.0': '#d91cf1'
  },
  shadowBlur: 5
})

const CustomSwitch = (props: Props) => {
  const { children } = props
  const [progress, setProgress] = useState(false)
  const [prevLoc, setPrevLoc] = useState('')
  const location = useLocation()
  const dispatch = useDispatch()
  useEffect(() => {
    setProgress(true)
    setPrevLoc(location.pathname)

    if (/^\/team\//.test(location.pathname)) window.scrollTo(0, 0)

    if (location.pathname === prevLoc) setPrevLoc('')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  useEffect(() => {
    setProgress(false)
    if (isMobile) dispatch(setOpenDrawer({ open: false }))
  }, [dispatch, prevLoc])
  return (
    <>
      {progress && <TopBarProgress />}
      <Switch>{children}</Switch>
    </>
  )
}

export default CustomSwitch
